export default __webpack_public_path__ + "static/media/carrer-development.a0b057e8.svg";